// 文件类型
export enum FileType {
  BANNER = 'banner', //广告成品样件示例
  PERMIT = 'permit', //医疗执业许可证示例
  APPLY = 'apply',
  SAMPLE = 'Sample',
  GGCPYJ = 'ggcpyj',
}

// 诊所值枚举--判断床位数
export const CLINIC = [
  'D212X',
  'D213X',
  'D214X',
  'D218X',
  'D222X',
  'D223X',
  'D120X',
  'D121X',
  'D122X',
  'D130X',
  'D140X',
]
//媒体类型 影视、广播
export const MEDIA = ['111001', '111002']
// 网络
export const NET = '111007'
// 其他
export const OTHER = '111008'

// 医疗结构类型 ---> 检验有效期
export const CLINIC_TYPE = ['D212X', 'D213X', 'D214X', 'D218X', 'D222X', 'D223X']
